import * as React from 'react';

import { FormFeedback } from 'reactstrap';

export interface FormErrorFeedbackProps {
  field: string;
  form: any;
}
export const FormErrorFeedback: React.SFC<FormErrorFeedbackProps> = props => {
  if (!props.form.errors[props.field] || !props.form.touched[props.field]) {
    return null;
  }
  return <FormFeedback>{props.form.errors[props.field]}</FormFeedback>;
};



// WEBPACK FOOTER //
// ./src/common/components/form/FormErrorFeedback.tsx